const UrlList = {
  IFSCFactory : "https://www.wengold.com/webss/ifsc/platform/#/",
  ICP: "http://beian.miit.gov.cn",
  VideoSrc: "https://xbeibeix.com/api/bilibili/biliplayer/?url=BV1G3411Y7TQ",
  VideoSrc1: "https://xbeibeix.com/api/bilibili/biliplayer/?url=BV1rS4y1j7xe",
}

export default UrlList